import {BaseRemoteConfiguration} from "../../infrastructure/models/base-remote-configuration";

export class PropositionBetsWidgetRemoteConfig extends BaseRemoteConfiguration {s}